import {
  getConfig,
  loginTestAccount,
} from '@/api/wechatminiprogramcfgserv'

export default {
  state: {
    state_WechatMiniProgramCfg_GetConfigResult: null,
    state_WechatMiniProgramCfg_LoginTestAccountResult: null,
  },
  mutations: {
    SET_WECHATMINIPROGRAMCFG_GETCONFIG_RESULT: (state, rst) => {
      state.state_WechatMiniProgramCfg_GetConfigResult = rst;
    },
    SET_WECHATMINIPROGRAMCFG_LOGINTESTACCOUNT_RESULT: (state, rst) => {
      state.state_WechatMiniProgramCfg_LoginTestAccountResult = rst;
    },
  },
  actions: {
    WechatMiniProgramCfgServ_GetConfig({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getConfig(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WECHATMINIPROGRAMCFG_GETCONFIG_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WECHATMINIPROGRAMCFG_GETCONFIG_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WechatMiniProgramCfgServ_LoginTestAccount({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        loginTestAccount(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WECHATMINIPROGRAMCFG_LOGINTESTACCOUNT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WECHATMINIPROGRAMCFG_LOGINTESTACCOUNT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_WechatMiniProgramCfg_GetConfigResult: state => {
      return state.state_WechatMiniProgramCfg_GetConfigResult;
    },
    get_WechatMiniProgramCfg_LoginTestAccountResult: state => {
      return state.state_WechatMiniProgramCfg_LoginTestAccountResult;
    },
  }
}